import React, { memo } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { CheckFilledIcon, ClockIcon, VarianceFlagIcon } from 'transfix-icons'
import { Tooltip, brandColors } from 'transfix-ui'
import { POD_STATES } from './utils'

interface IDocumentsProps {
  podState: POD_STATES
}

const POD_STATE_TO_TOOLTIP: Record<POD_STATES, string> = {
  [POD_STATES.ACCEPTED]: 'Proof of Delivery Accepted',
  [POD_STATES.APPROVED]: 'Proof of Delivery Approved',
  [POD_STATES.NEEDED]: 'Proof of Delivery Needed',
  [POD_STATES.REJECTED]: 'Proof of Delivery Rejected',
  [POD_STATES.PENDING]: 'Proof of Delivery In Review',
  [POD_STATES.MISSING]: 'No Proof of Delivery Added',
}

const icon = (podState: POD_STATES) => {
  switch (podState) {
    case POD_STATES.APPROVED:
    case POD_STATES.ACCEPTED:
      return <CheckFilledIcon color='green2' size='xlarge' />
    case POD_STATES.REJECTED:
    case POD_STATES.NEEDED:
      return <VarianceFlagIcon color='warning1' size='xlarge' />
    case POD_STATES.PENDING:
      return <ClockIcon color='coolGray5' size='xlarge' />
    case POD_STATES.MISSING:
    default:
      return (
        <Typography variant='h3' color={brandColors.coolGray4}>
          –
        </Typography>
      )
  }
}

export const Documents = memo<IDocumentsProps>(({ podState }) => {
  return (
    <Box display='flex'>
      <Tooltip position='top' type='dark' effect='solid' trigger={icon(podState)}>
        {POD_STATE_TO_TOOLTIP[podState]}
      </Tooltip>
    </Box>
  )
})
